import { useEffect } from 'react';

interface IUseVisibilityChangeParams {
  onVisible?: () => void;
  onHidden?: () => void;
}
// 自定义 Hook: 用于监听页面的可见性变化
export const useVisibilityChange = ({ onVisible, onHidden }: IUseVisibilityChangeParams) => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        onVisible?.();
      } else {
        onHidden?.();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [onVisible, onHidden]);
};
